import {
  takeLatest, takeEvery, put, call, all,
} from 'redux-saga/effects';
import * as actions from '@actions';
import Message from '@rootCommon/services';
import { IdType } from '@rootTypes/common';
import { FhqInvitation, FhqInvitationSetting, FHQStatus } from '@rootTypes/fhq';
import FhqInvitationSettingsService from '@services/fhq-invitation-settings';
import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch
function* fetchFhqInvitationSettingsAsync(action: { payload: IdType[] }) {
  try {
    const fhqInvitationSettings: { siteFhqId: IdType; settings: FhqInvitationSetting }[] = yield all(
      action.payload.map((siteFhqId) => call(FhqInvitationSettingsService.getBySiteFhqId, siteFhqId)),
    );

    yield put(actions.fetchFhqInvitationSettings.success(fhqInvitationSettings));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchFhqInvitationSettings.failure(error));
  }
}

function* watchFetchFhqInvitationSettings() {
  yield takeLatest(actions.fetchFhqInvitationSettings.request, fetchFhqInvitationSettingsAsync);
}

// update
function* updateFhqInvitationSettingAsync(action: { payload: FhqInvitation[] }) {
  try {
    const itemNonChanged: FhqInvitation[] = [];
    const itemUpdated: FhqInvitation[] = [];

    action.payload?.forEach((item) => {
      if (item.status === FHQStatus.UPDATE) {
        itemUpdated.push(item);
      } else {
        itemNonChanged.push(item);
      }
    });

    yield all(
      itemUpdated.map((item) => call(FhqInvitationSettingsService.updateBySiteFhqId, item.siteFhqId, item.settings)),
    );

    yield put(actions.updateFhqInvitationSettings.success(action.payload));
    Message.success('Invitation settings were successfully updated');
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.updateFhqInvitationSettings.failure(error));
  }
}

function* watchUpdateFhqInvitationSetting() {
  yield takeEvery(actions.updateFhqInvitationSettings.request, updateFhqInvitationSettingAsync);
}

// all
function* watchFhqInvitationSettings(): SagaGenerator {
  yield all([watchFetchFhqInvitationSettings(), watchUpdateFhqInvitationSetting()]);
}

export default watchFhqInvitationSettings;
